export default __webpack_public_path__ + "static/media/icon_warning_24px.2a381cef.svg";